module.exports = __webpack_public_path__ + "static/media/truckee.9ed91a14.png";